import axios from 'zzc-axios'
// import { cookie } from '@/common/util-front.js'

import { Loading, Message } from 'element-ui'
let loadingInstance = null
let countRequest = 0

function closeLoading() {
  if (--countRequest === 0) {
    loadingInstance.close()
  }
}

function openLoading() {
  loadingInstance = Loading.service({
    text: 'Loading...',
    background: 'rgba(255, 255, 255, 0.7)',
    spinner: 'el-icon-loading'
  })
}

// 基本配置
axios.defaults.timeout = 50000
// http请求拦截器
axios.interceptors.request.use(
  (config) => {
    config.withCredentials = true
    // 设置请求头token，用于登陆
    config.headers.Authorization = 'token'
    // 发送请求前的其他处理
    countRequest++
    if (!config.url.includes('/getVerifyCode')) {
      openLoading()
    }
    return config
  },
  (err) => {
    closeLoading()
    console.log('request err:*********', err)
    Message.error({
      showClose: true,
      message: err
    })
    return Promise.reject(err)
  }
)

// http响应拦截器
axios.interceptors.response.use(
  (res) => {
    closeLoading()
    // console.log('ggg=======', res)
    if (res.data.code !== 0 && res.data.code !== 'SUCCESS') {
      console.log('response data  err:*********', res.data.message)
      Message({
        type: 'error',
        duration: 60000,
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: res.data.message || res.data.msg
      })
    }
    return res
  },
  (err) => {
    closeLoading()
    console.log('response err:*********', err)
    Message.error({
      showClose: true,
      message: err
    })
    return Promise.reject(err)
  }
)

/**
 *
 *
 * @param {*} {
 *   url,
 *   method='get',
 *   isNeedLoading=true, //是否开启loading
 *   isNeedToken=true, //默认需要token参数
 *   loadingText='加载中..',
 *   isShowCatchErr=true,//默认显示catch错误异常
 *   ...option
 * }
 * @returns
 */
export function request({ url, method = 'get', ...option }) {
  const param = {
    url: url,
    method,
    ...option
  }
  return new Promise((resolve) => {
    axios(param)
      .then(async(res) => {
        resolve({
          res,
          ...res.data
        })
      })
      .catch(async(err) => {
        console.log(err, '---response err---')
      })
  }).catch((error) => {
    // 增加接口监控
    return Promise.reject(error)
  })
}
